export const DEFAULT_PAGE_MAX_WIDTH = 1920;

export type PageMaxWidth = number | string;
